// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Footer() {
  return (
    <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between', p: '24px 16px 0px', mt: 'auto' }}>
      <Typography variant="caption">
        &copy; All rights reserved{' '}
        <Link href="https://www.scholarbridge.co.in/" target="_blank" underline="hover">
          Scholar Bridge
        </Link>
      </Typography>
      <Stack direction="row" sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'space-between' }}>
        <Link href="/about" target="_blank" variant="caption" color="text.primary">
          About us
        </Link>
        <Link href="/privacy-policy" target="_blank" variant="caption" color="text.primary">
          Privacy Policy
        </Link>
        <Link href="/terms-and-conditions" target="_blank" variant="caption" color="text.primary">
          Terms & Conditions
        </Link>
      </Stack>
    </Stack>
  );
}
